import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import update from 'react-addons-update';

import resources from "../../data/resources";
import ClientData from "../../data/ClientData";
import moment from "moment/moment";
import {showFindClientModal} from "../../actions/FindClientAction";
import {showToast} from "../../actions/ToastAction";
import {selectClient} from "../../actions/ClientSelectActions";
import connect from "react-redux/es/connect/connect";
import {clientDialog} from "../../actions/ClientDialogAction";
import localDB from "../../data/localDB";

class ClientDialog extends Component {

    constructor() {
        super();

        this.state = {
            client: {
                full_name: '',
                identification: '',
                phone: '',
                email: '',
                address: '',
                id: null,
                birthdate: ''
            },
            full_name_error: false,
            email_error: false,
            index: null,
            btn_sending: false
        };

        this.handleFullNameChange = this.handleFullNameChange.bind(this);
        this.handleIdentificationChange = this.handleIdentificationChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleBirthdateClick = this.handleBirthdateClick.bind(this);
        this.handleBirthdateChange = this.handleBirthdateChange.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.client_dialog){
            this.setState({client:nextProps.client_dialog.client});
        }
    }

    handleFullNameChange = (event) => {
        let full_name = update(this.state, {
            client: {
                full_name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(full_name);
        if (event.target.value.trim() === '') {
            this.setState({full_name_error: true})
        } else {
            this.setState({full_name_error: false});
        }
    };

    handleAddressChange = (event) => {
        let address = update(this.state, {
            client: {
                address: {
                    $set: event.target.value
                }
            }
        });
        this.setState(address);
    };

    handleIdentificationChange = (event) => {
        let identification = update(this.state, {
            client: {
                identification: {
                    $set: event.target.value
                }
            }
        });
        this.setState(identification);
    };

    handlePhoneChange = (event) => {
        let phone = update(this.state, {
            client: {
                phone: {
                    $set: event.target.value
                }
            }
        });
        this.setState(phone);
    };

    handleEmailChange = (event) => {
        let email = update(this.state, {
            client: {
                email: {
                    $set: event.target.value.toLowerCase().trim()
                }
            }
        });
        this.setState(email);
        if (event.target.value.trim() !== '') {
            if (resources.validators.isValidEmailAddress(event.target.value)) {
                this.setState({email_error: false})
            } else {
                this.setState({email_error: true})
            }
        } else {
            this.setState({email_error: false})
        }
    };

    handleBirthdateClick = (selectedDay) => {
        let date = moment(selectedDay).format("YYYY-MM-DD");
        let client = update(this.state, {
            client: {
                birthdate: {
                    $set: date
                }
            }
        });
        this.setState(client);
    };

    handleBirthdateChange = (event) => {
        this.setState({date: event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({birthdate_error: true})
        } else {
            this.setState({date_error: false});
        }
    };

    async handleSubmit(event) {
        if (this.state.client.full_name === '') {
            this.setState({full_name_error: true});
        }else if (this.state.email_error) {
            this.setState({email_error: true});
        }else {
            event.preventDefault();
            this.setState({btn_sending: true});
            if (this.state.client.id) {
                ClientData.update(this.state.client, (res) => {
                    if (res !== null) {
                        localDB.addOrUpdateDB('clients', {id:res.id, identification: res.identification, full_name: res.full_name, phone: res.phone});
                        this.dispatchData(res, 'Cliente Actualizado');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde', type: 'error'});
                    }
                    this.setState({btn_sending: false});
                });
            } else {
                ClientData.add(this.state.client, (res) => {
                    if (res !== null) {
                        localDB.addOrUpdateDB('clients', {id:res.id, identification: res.identification, full_name: res.full_name, phone: res.phone});
                        this.dispatchData(res, 'Cliente Agregado');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde', type: 'error'});
                    }
                    this.setState({btn_sending: false});
                });
            }
        }
    };

    handleClose = () => {
        this.props.clientDialog({open: false, client:{id:null}});
    };

    dispatchData = (client, message) => {
        this.props.selectClient(client);
        this.props.clientDialog({open:false, client:{id:null}});
        this.props.showFindClientModal({open:false});
        this.props.showToast({message: message, type: 'success'});
    };

    render() {
        return (
            <div>
                <Modal dimmer='inverted' size='small' open={this.props.client_dialog.open} onClose={this.handleClose} ref='modal'>
                    <Modal.Header>{this.props.client_dialog.client.id ? 'Actualizar Cliente':'Nuevo Cliente'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid stackable>
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <Form.Input label='Cliente' placeholder='Cliente' required
                                                        value={this.state.client.full_name}
                                                        onChange={this.handleFullNameChange}
                                                        error={this.state.full_name_error}/>
                                            <Form.Input label='Teléfono' placeholder='Teléfono'
                                                        value={this.state.client.phone}
                                                        onChange={this.handlePhoneChange}/>
                                            <Form.Field error={this.state.birthdate_error}>
                                                <label>Fecha de Nacimiento</label>
                                                <DayPickerInput
                                                    readOnly
                                                    placeholder="YYYY-MM-DD"
                                                    format="YYYY-MM-DD"
                                                    value={this.state.client.birthdate}
                                                    onDayChange={this.handleBirthdateClick}
                                                    onChange={this.handleBirthdateChange}/>
                                            </Form.Field>

                                        </Grid.Column>
                                        <Grid.Column>
                                            <Form.Input label='Identicación' placeholder='Identicación'
                                                        value={this.state.client.identification}
                                                        onChange={this.handleIdentificationChange}/>
                                            <Form.Input label='Correo Electrónico' placeholder='Correo Electrónico'
                                                        value={this.state.client.email}
                                                        error={this.state.email_error}
                                                        onChange={this.handleEmailChange}/>
                                            <Form.Input label='Dirección' placeholder='Dirección'
                                                        value={this.state.client.address}
                                                        onChange={this.handleAddressChange}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' disabled={this.state.btn_sending} loading={this.state.btn_sending}
                                labelPosition='left' onClick={this.handleSubmit}
                                content={this.props.client_dialog.client.id ? 'Actualizar':'Guardar'}/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        client_dialog: state.get('client_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clientDialog(data) {
            dispatch(clientDialog(data));
        },
        selectClient(client){
            dispatch(selectClient(client))
        },
        showFindClientModal(data){
            dispatch(showFindClientModal(data))
        },
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClientDialog);


// WEBPACK FOOTER //
// ./src/components/contacts/ClientDialog.js